import React from 'react';
import { Modal, ModalContent, ModalActions, Button } from 'semantic-ui-react';
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth, unregisterNotifications } from '../../utils/firebase';
import { useToast } from '../toast/ToastContext';

export const LogoutDialog = ({ logoutOpen, setLogoutOpen, user }) => {
  const navigate = useNavigate();
  const toast = useToast();

  const logout = () => {
    if (user.email) {
      unregisterNotifications(user.uid, () => {
        toast.success("Push notifikácie vypnuté.")
      });
    }
    signOut(auth).then(() => {
      setLogoutOpen(false);
      navigate("/")
    }).catch((error) => {
      setLogoutOpen(false);
    });
  }

  return <Modal
    dimmer='blurring'
    open={logoutOpen}
    onCancel={() => setLogoutOpen(false)}
  >
    <ModalContent>
      Naozaj sa chceš odhlásiť?
    </ModalContent>
    <ModalActions>
      <Button onClick={() => setLogoutOpen(false)}>
        Zrušiť
      </Button>
      <Button onClick={logout}>
        Odhlásiť
      </Button>
    </ModalActions>
  </Modal>
}
